export default __webpack_public_path__ + "static/char-s-46-en-dc9a1e45736808bea8981599f806da95.png";